// MagicDesk, Super Narrate and Video Studio each keep one fixed colour on
// every theme (like Exam Prep gold). These helpers make that colour read:
// a deeper shade to sit behind white text, and a version pulled toward the
// theme's own text colour for labels on light and dark surfaces alike.
export const featureFill = (hex) => `color-mix(in srgb, ${hex} 72%, #000)`;
export const featureInk = (hex) => `color-mix(in srgb, ${hex} 55%, var(--st-ink))`;
